import React from "../../_snowpack/pkg/react.js";
import useSanitize from "../hooks/useSanitize.js";
const EmailView = ({raw}) => {
  const sanitized = useSanitize(raw);
  return /* @__PURE__ */ React.createElement("div", {
    dangerouslySetInnerHTML: {__html: sanitized}
  });
};
export default EmailView;
